import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { inject, getCurrentInstance, ComponentInternalInstance } from 'vue';
import { useRoute } from 'vue-router';
import type { MenuStore } from './menu.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'item',
  props: {
    disabled: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

/*
 * @author: Lew
 * @e-mail: yaol@jiguang.cn
 * @date: 2022/08/18 18:00:27
 * @description: 菜单项
 */

const route = useRoute();
const instance = getCurrentInstance() as ComponentInternalInstance;
const key = String(instance.vnode.key);
const setMenuStore = inject<MenuStore>('menuStore', { selectedKey: '' });
const handleSelect = () => {
  setMenuStore.selectedKey = key;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("li", {
    class: _normalizeClass([
      `${_unref(setMenuStore).prefixCls ? _unref(setMenuStore).prefixCls + '-' : ''}menu-item`,
      `${_unref(setMenuStore).prefixCls ? _unref(setMenuStore).prefixCls + '-' : ''}menu-item-model--${
        _unref(setMenuStore).mode
      }`,
      _unref(setMenuStore).selectedKey === _unref(key) &&
        `${_unref(setMenuStore).prefixCls ? _unref(setMenuStore).prefixCls + '-' : ''}menu-item-model--${
          _unref(setMenuStore).mode
        }--active`,
      _ctx.disabled && 'disabled',
    ]),
    onClick: handleSelect
  }, [
    _renderSlot(_ctx.$slots, "icon"),
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}
}

})